module.exports = __webpack_public_path__ + "static/media/api_2.abd0d9d3.svg";